import {RoutePaths} from "../../shared/routePaths";
import {Redirect} from "react-router-dom";
import React from "react";
import {useLocation} from "react-router";
import {QueryParams} from "../../shared/enums/queryParams";
import {useStores} from "../../stores/useStores";

const withRedirectWithoutASelectedVillage =
  (Component: any) => (props: any) => {
    const {uiStore} = useStores();
    const search = useLocation().search;
    const queryParams = React.useMemo(
      () => new URLSearchParams(search),
      [search]
    );
    const villageId = queryParams.get(QueryParams.VillageId);
    const canCreateTemplate = uiStore.accountStore.abilities.can(
      "Create",
      "EventCatalogue"
    );
    if (!villageId) {
      return (
        <Redirect
          to={{
            pathname: canCreateTemplate
              ? RoutePaths.EventCatalogue
              : RoutePaths.Events,
            search: canCreateTemplate
              ? ""
              : `${QueryParams.VillageId}=${uiStore.selectableVillages.items[0].value}`,
            state: {from: props.location}
          }}
        />
      );
    }
    return <Component {...props} />;
  };

export default withRedirectWithoutASelectedVillage;
